import { render, staticRenderFns } from "./added-list.vue?vue&type=template&id=056e99ce&scoped=true&"
import script from "./added-list.vue?vue&type=script&lang=js&"
export * from "./added-list.vue?vue&type=script&lang=js&"
import style0 from "./added-list.vue?vue&type=style&index=0&id=056e99ce&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056e99ce",
  null
  
)

export default component.exports